/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnAssignProjectFromProgramCommand } from '../../models/un-assign-project-from-program-command';
import { UnAssignProjectFromProgramCommandResult } from '../../models/un-assign-project-from-program-command-result';

export interface ApiProjectUnAssignProjectFromProgramPost$Params {
      body?: UnAssignProjectFromProgramCommand
}

export function apiProjectUnAssignProjectFromProgramPost(http: HttpClient, rootUrl: string, params?: ApiProjectUnAssignProjectFromProgramPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UnAssignProjectFromProgramCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectUnAssignProjectFromProgramPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnAssignProjectFromProgramCommandResult>;
    })
  );
}

apiProjectUnAssignProjectFromProgramPost.PATH = '/api/Project/UnAssignProjectFromProgram';
